(ns practitest.frontend.global-fields-settings.common
  (:require [clojure.string :as string]))

(def global-field-icon "🌐")

(defn strip-global-field-icon
  [label]
  (if (and (string? label) (string/starts-with? label global-field-icon))
    (string/triml (subs label 2))
    label))

(def global-field-form-id :global-fields-form)

(def ^:private field-format-labels
  {"text"       "Text"
   "memo"       "Memo"
   "number"     "Number"
   "list"       "List"
   "date"       "Date"
   "datetime"   "Date Time"
   "checkbox"   "Checkbox"
   "user"       "User"
   "linkedlist" "Linked List"
   "multilist"  "Multi list"
   "url"        "URL"})

(defn get-field-format-label [field-format-value]
  (get field-format-labels field-format-value field-format-value))

(def entities
  {:test "QtestDesign"
   :requirement "Requirement"
   :issue "Issue"
   :milestone "Milestone"
   :testSets "Suite"
   :instances "Instance"
   :run "QtestRun"})